// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const umaxxColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: umaxxColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: umaxxColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: umaxxColors.primaryGray,
    secondary: umaxxColors.secondaryGray,
    disabled: umaxxColors.grayText,
    link: umaxxColors.secondaryGray,
    hint: umaxxColors.white,
    highlight: umaxxColors.secondary,
    gray: umaxxColors.primaryGray,
    seeAll: umaxxColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: umaxxColors.primaryGray,
    gray: umaxxColors.secondaryGray,
  },
  filter: {
    primary: umaxxColors.primaryGray,
    secondary: umaxxColors.secondaryGray,
    disabled: umaxxColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: umaxxColors.dark,
    color: umaxxColors.white,
    border: umaxxColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: umaxxColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: umaxxColors.dark,
        selected: umaxxColors.dark,
        progress: rgba(umaxxColors.primary, 0.3),
        past: rgba(umaxxColors.primary, 0.3),
        pastSelected: umaxxColors.dark,
        pastHover: umaxxColors.dark,
        empty: '#555555',
        emptyProgress: rgba(umaxxColors.primary, 0.2),
      },
      text: {
        empty: umaxxColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: umaxxColors.white,
    subTitle: umaxxColors.secondaryGray,
    bg: umaxxColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
